var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fieldset',[_c('legend',[_vm._v(_vm._s(_vm.legend))]),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }